import { create } from "zustand";
import { devtools } from "zustand/middleware";

const initialState = {
  isChatOpen: false,
  hasChatInitialized: false
};

const useChatStore = create(
  devtools(
    (set) => ({
      ...initialState,
      setChatOpen: (isOpen) => {
        set({ 
          isChatOpen: isOpen,
          hasChatInitialized: true 
        }, false, 'setChatOpen');
      },
      toggleChat: () => {
        set((state) => ({ 
            isChatOpen: !state.isChatOpen,
          hasChatInitialized: true
        }), false, 'toggleChat');
      },
      resetChat: () => {
        set(initialState, false, 'resetChat');
      },
    })
  )
);

export default useChatStore;